import AddToGroupPopover from './AddToGroupPopup';
import AddToGroupPopoverContainer from './AddToGroupPopup.container';
export default AddToGroupPopoverContainer(AddToGroupPopover);
